import { RECURRENCE_OPTIONS } from "./todoConstants";

export const emptyTemplate = () => ({
  id: null,
  title: "",
  category: "",
  description: "",
  recurrence: "none",
  due_offset_days: 0,
  task_reference_type: "",
  task_reference_id: null,
  task_reference: null,
  target_employee_position_ids: [],
  target_user_ids: [],
  active: true,
});

export const normalizeTemplatesForCompare = (rows) =>
  (Array.isArray(rows) ? rows : [])
    .filter((row) => row?.title?.trim())
    .map((row) => ({
      id: row.id || null,
      title: row.title?.trim() || "",
      category: row.category?.trim() || "",
      description: row.description?.trim() || "",
      recurrence: row.recurrence || "none",
      due_offset_days: Number(row.due_offset_days) || 0,
      task_reference_id: row.task_reference_id || null,
      target_employee_position_ids: [...(row.target_employee_position_ids || [])].sort((a, b) => a - b),
      target_user_ids: [...(row.target_user_ids || [])].sort((a, b) => a - b),
      active: row.active !== false,
    }));

export const positionSortKey = (row, employeePositions) => {
  const ids = row?.target_employee_position_ids || [];
  if (!ids.length) return "";
  const names = ids
    .map((id) => employeePositions.find((pos) => pos.id === id)?.name)
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, "nb"));
  return names.join(", ");
};

export const compareTemplates = (a, b, employeePositions) => {
  const catA = (a.category || "").trim().toLowerCase();
  const catB = (b.category || "").trim().toLowerCase();
  if (catA !== catB) {
    if (!catA) return 1;
    if (!catB) return -1;
    return catA.localeCompare(catB, "nb");
  }

  const posA = positionSortKey(a, employeePositions).toLowerCase();
  const posB = positionSortKey(b, employeePositions).toLowerCase();
  if (posA !== posB) {
    if (!posA) return 1;
    if (!posB) return -1;
    return posA.localeCompare(posB, "nb");
  }

  return (a.title || "").localeCompare(b.title || "", "nb");
};

export const recurrenceLabel = (value, t) => {
  const match = RECURRENCE_OPTIONS.find((opt) => opt.value === value);
  return match ? t(match.labelKey) : value || "";
};

export const buildTemplateSummaryParts = (row, { t, employeePositions, selectedEmployeesByRow }) => {
  const parts = [];

  if (row.category?.trim()) {
    parts.push(row.category.trim());
  }

  const positionNames = (row.target_employee_position_ids || [])
    .map((id) => employeePositions.find((pos) => pos.id === id)?.name)
    .filter(Boolean);
  if (positionNames.length) {
    parts.push(positionNames.join(", "));
  }

  if (row.recurrence && row.recurrence !== "none") {
    parts.push(recurrenceLabel(row.recurrence, t));
  }

  if (row.task_reference?.displayTitle || row.task_reference_id) {
    parts.push(row.task_reference?.displayTitle || `#${row.task_reference_id}`);
  }

  const assigneeCount = (row.target_user_ids || []).length;
  if (assigneeCount) {
    parts.push(t("todo.settingsAssigneeCount", { count: assigneeCount }));
  }

  if (row.due_offset_days > 0) {
    parts.push(t("todo.settingsDueOffsetSummary", { days: row.due_offset_days }));
  }

  return parts;
};
